import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    return from(this.auth.returnTokenUser()).pipe(
      switchMap((token) => {
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
        
        return next.handle(request);
      })
    );
  }
}

/*
return from(this.storage.getObject(environment.config.tokenKey)).pipe(
  switchMap((initialToken) => {        
    const isExpired = helperJWT.isTokenExpired(initialToken);
    let test = isExpired ? localStorage.getItem(environment.config.tokenKey) : initialToken;
    if (test) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${test}`,
        },
      });
    }
    
    return next.handle(request);
  })
);
}
*/